export default "__VITE_ASSET__CCHP3aIv__"